import React, { useState } from "react";
import { Button, Checkbox, Modal, notification } from "antd";
import { useTranslation, Trans } from "react-i18next";
import { agreeToTerms } from "../../api/users";

export const TermsAndConditionsModal = ({ isOpen }) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const agreeToTermsAndConditions = async () => {
    try {
      setIsLoading(true);
      await agreeToTerms();
      setHasAccepted(true);
      notification.success({
        message: t('termsAndConditions.agreeSuccess'),
      });
    } catch (e) {
      notification.error({
        message: t('termsAndConditions.agreeError'),
      });
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      closeIcon={<></>}
      title={<h3 className="text-center"> {t('termsAndConditions.title')} </h3>}
      open={isOpen && !hasAccepted}
      footer={null}
    >
      <span>
        <Trans i18nKey="termsAndConditions.intro">
          To continue using this application, you must read and accept our <a href="https://teamsunday.com/legal/terms-and-conditions/" target="_blank">Terms &amp; Conditions</a> and <a href="https://teamsunday.com/legal/privacy-policy/" target="_blank">Privacy Policy.</a>
        </Trans>
      </span>

      <div>
        <Checkbox
          onChange={(e) => setIsChecked(e.target.checked)}
          className="mt-2 w-100"
        >
          <h5>
            {t('termsAndConditions.checkboxLabel')}
          </h5>
        </Checkbox>
      </div>

      <Button
        className="mt-3 w-100"
        type="primary"
        disabled={!isChecked}
        loading={isLoading}
        onClick={agreeToTermsAndConditions}
      >
        {t('termsAndConditions.acceptButton')}
      </Button>
    </Modal>
  );
};
